import ee from '../../assets/svg/flags/ee.svg';
import gb from '../../assets/svg/flags/gb.svg';
import ru from '../../assets/svg/flags/ru.svg';

export default [
  { label: 'EST', value: 'et', flag: ee },
  { label: 'ENG', value: 'en', flag: gb },
  { label: 'RUS', value: 'ru', flag: ru },
];
